import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material';

import { Text } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { llmModelOptions } from '../../Llm/Shared/SharedFormFields';

export function InformationExtractionModelSettingsFormField() {
  return (
    <Accordion variant="elevation">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Text variant="heading5">Model settings</Text>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <BlockValueTemplateField
            fieldName="config.additionalPrompt"
            label="Prompt for extraction guidance (optional)"
          />
          <BlockValueTemplateField
            fieldName="config.rankingPrompt"
            label="Prompt for ranking and filtering results (optional)"
          />
          <BlockSelectField label="Model" fieldName="config.modelName" options={llmModelOptions} />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
